import { BankDetails } from './cards/bank-details';
import { HealthCareDetails } from './cards/health-care-details';
import { HistoryDetails } from './cards/history-details';
import { PersonalDetails } from './cards/personal-details';
import { TaxDetails } from './cards/tax-details';
import { PersonalDetailsModel } from 'features/employees/api/models/employee';
import { UpdateEmployeePersonalDetailsInput } from 'features/employees/api/repositories/use-employee-personal-details-update.mutation';
import { FC } from 'react';
import {
  Control,
  FieldErrors,
  FieldNamesMarkedBoolean,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch
} from 'react-hook-form';

type Props = {
  isSubmitting: boolean;
  isLoading: boolean;
  register: UseFormRegister<UpdateEmployeePersonalDetailsInput>;
  getValues: UseFormGetValues<UpdateEmployeePersonalDetailsInput>;
  setValue: UseFormSetValue<UpdateEmployeePersonalDetailsInput>;
  trigger: UseFormTrigger<UpdateEmployeePersonalDetailsInput>;
  touchedFields: Partial<Readonly<FieldNamesMarkedBoolean<UpdateEmployeePersonalDetailsInput>>>;
  errors: FieldErrors<UpdateEmployeePersonalDetailsInput>;
  queryResult: PersonalDetailsModel | undefined;
  control: Control<UpdateEmployeePersonalDetailsInput, any>;
  watch: UseFormWatch<UpdateEmployeePersonalDetailsInput>;
};

const PersonalDetailsSection: FC<Props> = ({
  isSubmitting,
  isLoading,
  control,
  trigger,
  getValues,
  setValue,
  register,
  touchedFields,
  errors,
  watch
}) => {
  return (
    <form noValidate className="form">
      <PersonalDetails
        control={control}
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        register={register}
        trigger={trigger}
        getValues={getValues}
        setValue={setValue}
        errors={errors}
        touchedFields={touchedFields}
        watch={watch}
      />
      <HealthCareDetails
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        register={register}
        errors={errors}
        touchedFields={touchedFields}
      />
      <BankDetails
        isSubmitting={isSubmitting}
        isLoading={isLoading}
        register={register}
        errors={errors}
        touchedFields={touchedFields}
      />
      <TaxDetails isLoading={isLoading} control={control} />
      <div className="fs-6 text-muted px-9 py-9">
        If you do not give sufficient information, then Advance Motors will use a code OT. For a basic rate taxpayer,
        this will produce the same result as a BR code, but for higher and additional rate taxpayers, the OT code will
        ensure that they are taxed at these higher rates. An OT code gives you no tax- free pay, but unlike BR, DO or D1
        codes it is not a flat rate. It takes account of the basic rate, higher rate and additional rate tax bands, so
        the rate of tax increases as earnings increase. This will only affect people whose earnings in a pay period
        exceed the basic rate tax band. For a basic rate taxpayer it will produce the same result as a BR code (a flat
        rate 20% deduction), but for a higher or additional rate taxpayer, the OT code will charge tax at 40% and 45% as
        income increases.
      </div>
      <HistoryDetails id={getValues('input.id')} />
    </form>
  );
};

export { PersonalDetailsSection };
